var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShowComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.71,5.29l-2-2L20,3H4l-.71.29-2,2L1,6v9l.29.71,2,2L4,18H6.43l2.71,4.51h1.72L13.57,18H20l.71-.29,2-2L23,15V6ZM21,14.59,19.59,16H13l-.86.49L10,20.06,7.86,16.49,7,16H4.41L3,14.59V6.41L4.41,5H19.59L21,6.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowComments);
export default __webpack_public_path__ + "static/1773309961/media/icon-show-comments.308ff7d252c9781afc61e6779a9987df.svg";
export { ForwardRef as ReactComponent };